import React from "react";
import Wrp from '../../../../hoc/Wrp/Wrp';
import Icons from "../../../../Components/Icons/Icons";

const uploadSection = (props) => {
    return(
        <Wrp>
            <div className="d-flex align-items-center justify-content-between">                       
                <a className="text-info textUnderline cursor-pointer" onClick={e=>props.toggleDirectoryChoosePopup('Upload','')}>
                  <Icons iconType="UploadIconWhite" /> Upload 
                </a>                           
            </div>
            <div className="clear"> </div>
        </Wrp>
    )
}

export default uploadSection;